import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LeavePolicyDetails } from './types'

interface LeavePoliciesState {
    leavePolicyDetails: LeavePolicyDetails[]
}

const initialState: LeavePoliciesState = {
    leavePolicyDetails: [],
}

const leavePolicyDetailsSlice = createSlice({
    name: 'leavePolicyDetails',
    initialState,
    reducers: {
        setLeavePolicyDetails(
            state,
            action: PayloadAction<LeavePolicyDetails[]>
        ) {
            state.leavePolicyDetails = action.payload
        },
        addLeavePolicyDetails(
            state,
            action: PayloadAction<LeavePolicyDetails>
        ) {
            state.leavePolicyDetails.push(action.payload)
        },
        updateLeavePoliciesDetails(
            state,
            action: PayloadAction<LeavePolicyDetails>
        ) {
            const index = state.leavePolicyDetails.findIndex(
                (policy) => policy.id === action.payload.id
            )
            if (index !== -1) {
                state.leavePolicyDetails[index] = action.payload
            }
        },
    },
})

export const {
    setLeavePolicyDetails,
    addLeavePolicyDetails,
    updateLeavePoliciesDetails,
} = leavePolicyDetailsSlice.actions

export default leavePolicyDetailsSlice.reducer
